import dayjs from "dayjs";

export const formatDayJsObjectToFormattedDateString = (
  value: dayjs.Dayjs | string
) => {
  if (typeof value === "string") {
    const dayJSValueFromString = dayjs(value);
    return `${dayJSValueFromString.format("YYYY-MM-DD")} 00:00:00`;
  }
  return `${value.format("YYYY-MM-DD")} 00:00:00`;
};
